export const linkColor = "#1c7ed6";
